import {FormProvider, useForm} from 'react-hook-form';
import {Link, useNavigate} from 'react-router';

import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';
import {useAuth} from 'context/AuthContext';

import './Login.scss';


export default function LoginPage() {
  const appContext = useAppContext();
  const {setIsAuthenticated} = useAuth();
  const navigate = useNavigate();

  const formMethods = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });
  const {handleSubmit, setError} = formMethods;

  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.post('api/v1/users/login', {
        json: values,
        parseJson: true,
      });

      if (rez?.data.user.mfa) {
        navigate('/mfa', {state: rez?.data.user.userId});
      } else {
        localStorage.setItem('login', 'true');
        setIsAuthenticated(true);
        navigate('/');
      }
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  const text = 'Don\'t remember your password?';

  return (
    <div className="loginPage">
      <FormProvider {...formMethods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3 className="text-center mb-3">Log in to your account</h3>
          <FormText
            label="Email address"
            name="email"
            required={true}
            className="my-custom-input mb-3"
          />
          <FormText
            label="Password"
            name="password"
            required={true}
            type="password"
            className="my-custom-input"
          />
          <div className="text-center mt-3">
            <Link to="/resetpassword">{text}</Link>
          </div>
          <div className="text-center mt-3">
            <FormError />
            <FormSubmit key="login" className="btn btn-lg btn-outline-light bg-black text-white">Log In</FormSubmit>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
